export const DEFAULT_INTERFACE_COLOR = "#040B20";
